import axios from "axios";
import { aiToolApiUrl } from "../Config/Url";

const OPEN_AI_URL = `${aiToolApiUrl}/aitool/openai`;
const ASSISTANT_URL = `${aiToolApiUrl}/aitool/assistant`;

async function translate(data) {
  return fetch(`${aiToolApiUrl}/aitool/openai/translate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.text());
}

async function generate(data) {
  return fetch(`${aiToolApiUrl}/aitool/openai/generate-article`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.text());
}

async function proofread(data) {
  return fetch(`${aiToolApiUrl}/aitool/openai/proofread`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.text());
}

async function generateAnswer(data) {
  return fetch(`${aiToolApiUrl}/aitool/openai/generate-answer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.text());
}

const getAssistantChat = (params = { sort: "updatedAt" }) => {
  return axios
    .get(`${ASSISTANT_URL}/chat`, {
      params: { chatAIType: 2, ...params },
    })
    .then((res) => res);
};

const deleteAssistantChat = (params) => {
  return axios
    .delete(`${ASSISTANT_URL}/chat`, {
      params,
    })
    .then((res) => res);
};

const getAssistantChatMessage = (params = {}) => {
  return axios
    .get(`${ASSISTANT_URL}/chat/messages`, {
      params,
    })
    .then((res) => res);
};

const postAssistantChatPrompt = (body, controller) => {
  const headers = controller
    ? {
        signal: controller.signal,
      }
    : {};
  return axios
    .post(`${ASSISTANT_URL}/chat/prompt`, body, headers)
    .then((res) => res);
};

export const AIToolServices = {
  translate,
  generate,
  proofread,
  generateAnswer,
  getAssistantChat,
  deleteAssistantChat,
  getAssistantChatMessage,
  postAssistantChatPrompt,
};
